import { t } from "../../i18n";
import { useEffect, useState } from "react";
import type { ProjectVersionDto } from "@tasduvar/shared";
import { api, errorMessage } from "../../api/client";
import { useProjectStore } from "../../state/projectStore";
import { cloudStore } from "../../storage";
import { Button } from "../../ui/Button";
import { Dialog } from "../../ui/Dialog";

export function VersionHistory({ open, onClose }: { open: boolean; onClose: () => void }): JSX.Element | null {
  const { project, openProject } = useProjectStore();
  const [items, setItems] = useState<ProjectVersionDto[]>([]);
  const [err, setErr] = useState<string>();
  useEffect(() => { if (open && project) void api<ProjectVersionDto[]>("GET", `/projects/${project.id}/versions`).then(setItems).catch((e: unknown) => setErr(errorMessage(e))); }, [open, project]);
  if (!open || !project) return null;
  const restore = async (v: ProjectVersionDto): Promise<void> => {
    if (!window.confirm("Bu sürüm geri yüklensin mi? Mevcut hâl geçmişe eklenir.")) return;
    try { await api("POST", `/projects/${project.id}/versions/${v.id}/restore`, {}); const p = await cloudStore.pull(project.id); if (p) openProject(p, "cloud"); onClose(); }
    catch (e) { setErr(errorMessage(e)); }
  };
  return (
    <Dialog open onClose={onClose} label={t("Sürüm geçmişi")} width={640} footer={<Button variant="ghost" onClick={onClose}>{t("Kapat")}</Button>}>
      <p className="text-[11px] text-cad-ink3">{t("son 20 kayıt")}</p>
      {err ? <p role="alert" className="text-xs text-bad">{err}</p> : null}
      {items.length === 0 ? <p className="text-sm text-stone">{t("Henüz önceki sürüm yok.")}</p> : (
        <div className="max-h-80 overflow-auto"><table className="w-full" aria-label={t("Sürüm geçmişi")}>
          <thead><tr><th>{t("Tarih")}</th><th>{t("Özet")}</th><th>{t("Not")}</th><th></th></tr></thead>
          <tbody>{items.map((v) => (
            <tr key={v.id} className="hover:bg-cad-select">
              <td className="font-mono whitespace-nowrap">{new Date(v.savedAt).toLocaleString("tr-TR")}</td><td className="font-mono text-cad-ink3">{v.digest.slice(0, 12)}</td><td>{v.note ?? ""}</td>
              <td className="text-right"><Button variant="ghost" onClick={() => void restore(v)}>{t("Geri yükle")}</Button></td>
            </tr>
          ))}</tbody>
        </table></div>
      )}
    </Dialog>
  );
}
